var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "share-application-container" } }, [
    _c("p", [
      _vm._v(_vm._s(_vm.$t("request-package.chooseFlow.youcanNowBundle"))),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row my-4" },
      [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "b-col",
          { attrs: { cols: "11" } },
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "10", md: "8", lg: "5" } },
                  [
                    _c("p", { staticClass: "bold mb-0" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.mainApplicantName) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "material-input",
                      {
                        staticClass: "mb-3",
                        attrs: {
                          type: "email",
                          label: _vm.$t("global.words.email"),
                          "label-for": "current-share-client-email",
                          "hidden-label": "",
                        },
                        model: {
                          value: _vm.computedClientEmail,
                          callback: function ($$v) {
                            _vm.computedClientEmail = $$v
                          },
                          expression: "computedClientEmail",
                        },
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.computedClientEmail,
                              expression: "computedClientEmail",
                            },
                          ],
                          staticClass:
                            "form-control form-control-sm material-input-static-label form-control-filled",
                          attrs: {
                            id: "current-share-client-email",
                            type: "email",
                            name: "emailToSend",
                          },
                          domProps: { value: _vm.computedClientEmail },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.computedClientEmail = $event.target.value
                            },
                          },
                        }),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "10", md: "8", lg: "5" } },
                  _vm._l(_vm.applicantsWithoutMainApplicant, function (ref) {
                    var id = ref.id
                    var applicantFullName = ref.applicantFullName
                    var email = ref.email
                    return _c("div", { key: id }, [
                      _c("p", { staticClass: "bold mb-2" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(applicantFullName) +
                            "\n            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "\n              " + _vm._s(email) + "\n            "
                        ),
                      ]),
                    ])
                  }),
                  0
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("article", [
      _c("div", { staticClass: "row mb-4" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "col-10" }, [
          _c("div", { staticClass: "row no-gutters justify-content-between" }, [
            _c(
              "div",
              {
                staticClass:
                  "img-checkbox d-flex align-items-center flex-column col-12 col-lg-3",
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.computedIncludeSendApplication,
                      expression: "computedIncludeSendApplication",
                    },
                  ],
                  attrs: {
                    id: "includeSendApplication",
                    type: "checkbox",
                    name: "includeSendApplication",
                  },
                  domProps: {
                    checked: _vm.includeSendApplication,
                    checked: Array.isArray(_vm.computedIncludeSendApplication)
                      ? _vm._i(_vm.computedIncludeSendApplication, null) > -1
                      : _vm.computedIncludeSendApplication,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.computedIncludeSendApplication,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            (_vm.computedIncludeSendApplication = $$a.concat([
                              $$v,
                            ]))
                        } else {
                          $$i > -1 &&
                            (_vm.computedIncludeSendApplication = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.computedIncludeSendApplication = $$c
                      }
                    },
                  },
                }),
                _vm._v(" "),
                _c("img", {
                  staticClass: "img-property big",
                  attrs: {
                    src: require("@Shared/@Assets/img/complete-application.png"),
                    alt: _vm.$t(
                      "request-package.chooseFlow.inviteClienttoCompleteApplication"
                    ),
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "inside-box",
                    attrs: { for: "includeSendApplication" },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "request-package.chooseFlow.inviteClienttoCompleteApplication"
                        )
                      )
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "img-checkbox d-flex align-items-center flex-column col-12 col-lg-3",
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.computedIncludeRequestDocuments,
                      expression: "computedIncludeRequestDocuments",
                    },
                  ],
                  attrs: {
                    id: "includeRequestDocuments",
                    type: "checkbox",
                    name: "includeRequestDocuments",
                  },
                  domProps: {
                    checked: _vm.includeRequestDocuments,
                    checked: Array.isArray(_vm.computedIncludeRequestDocuments)
                      ? _vm._i(_vm.computedIncludeRequestDocuments, null) > -1
                      : _vm.computedIncludeRequestDocuments,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.computedIncludeRequestDocuments,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            (_vm.computedIncludeRequestDocuments = $$a.concat([
                              $$v,
                            ]))
                        } else {
                          $$i > -1 &&
                            (_vm.computedIncludeRequestDocuments = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.computedIncludeRequestDocuments = $$c
                      }
                    },
                  },
                }),
                _vm._v(" "),
                _c("img", {
                  staticClass: "img-property big",
                  attrs: {
                    src: require("@Shared/@Assets/img/request-documents.png"),
                    alt: _vm.$t("request-package.steps.requestDocuments"),
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "inside-box",
                    attrs: { for: "includeRequestDocuments" },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("request-package.steps.requestDocuments"))
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "img-checkbox d-flex align-items-center flex-column col-12 col-lg-3",
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.computedincludeRequestBankStatements,
                      expression: "computedincludeRequestBankStatements",
                    },
                  ],
                  attrs: {
                    id: "includeRequestBankStatements",
                    type: "checkbox",
                    name: "includeRequestBankStatements",
                  },
                  domProps: {
                    checked: _vm.includeRequestBankStatements,
                    checked: Array.isArray(
                      _vm.computedincludeRequestBankStatements
                    )
                      ? _vm._i(_vm.computedincludeRequestBankStatements, null) >
                        -1
                      : _vm.computedincludeRequestBankStatements,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.computedincludeRequestBankStatements,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            (_vm.computedincludeRequestBankStatements =
                              $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.computedincludeRequestBankStatements = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.computedincludeRequestBankStatements = $$c
                      }
                    },
                  },
                }),
                _vm._v(" "),
                _c("img", {
                  staticClass: "img-property big",
                  attrs: {
                    src: require("@Shared/@Assets/img/bank-statements.png"),
                    alt: "$t('request-package.steps.requestBankStatements')",
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "inside-box",
                    attrs: { for: "includeRequestBankStatements" },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t("request-package.steps.requestBankStatements")
                      )
                    ),
                  ]
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-1 d-flex flex-column align-items-center step-circle-container",
      },
      [_c("div", { staticClass: "step" }, [_vm._v("1")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-1 d-flex flex-column align-items-center step-circle-container",
      },
      [_c("div", { staticClass: "step" }, [_vm._v("2")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }